import isWxProgram from "@/helper/isWxProgram";
import axios from 'axios'
export function openCustomerServiceChat(){
	isWxProgram()
	.then((res) => {
	  wx.miniProgram.navigateTo({ url: "/pages/openCustomerServiceChat/main" });
	})
	.catch((err) => {
	  window.open("https://work.weixin.qq.com/kfid/kfc7947cc4a9f23cce6")
	});
}
export const getCookieByKey = (key = '') => {
	if(!key) return ''
	const strArr = document.cookie.split(';')
	const cookieObject = strArr.reduce( (total, ele ,index) => Object.assign(total,{
		[ele.split('=')[0].trim()]:ele.split('=')[1]
	}),{})
	return cookieObject[key]
}
export const formatUrl = (baseUrl, query) => {
	const queryArr = Object.keys(query)
	if(!queryArr.length) return baseUrl
	return queryArr.reduce( (total, key, index) => (
		total += index === 0 ? key + '=' + query[key] : '&' + key + '=' + query[key]
	), baseUrl + (baseUrl ? '?' : ''))
}
export const  goMiniProgram = (path = '',query = {}) => {
	const newQuery = {
		...query,
		cookie: encodeURIComponent(document.cookie)
	}
	const url = formatUrl(path,newQuery)
	wx.miniProgram.navigateTo({url})
	// isWxProgram().
	// then((res) => {
	// 	const url = formatUrl(path,newQuery)
	// 	wx.miniProgram.navigateTo({url})
	// }).
	// catch(() => { // 非微信小程序环境
	// 	const params = {
	// 		bhAppId: 10,
	// 		path,
	// 		query:formatUrl('',newQuery),
	// 	}
	// 	axios.get(`/genericV1/v2/wechat/urlLink`,{params}).
	// 	then(res => {
	// 		window.open(res?.data?.data,'_blank')
	// 	})
	// })
}